// extracted by mini-css-extract-plugin
export default {"card":"EditSecurityPopup_card_ITsgP","column":"EditSecurityPopup_column_CBrCT"};